import React from 'react';
import { monsterClassFromId } from '../../../monsters';
import { Trans } from '@lingui/macro';

export default function DeathAnimated(props) {
  let typeSpecificContent;
  if (props.deathType === "black-hole") {
    typeSpecificContent = <>
      <div id="black-hole"></div>
      <div id="player-death-funny-message"><Trans>BYE BYE!</Trans></div>
    </>;
  } else {
    typeSpecificContent = <div id="hammer"></div>;
  }

  return <div className={`animation-player-death-${props.deathType}`}>
    <div className="player-death-animation-content">
      {typeSpecificContent}
      <div id="monster-dying" className={`game-sprite ${monsterClassFromId(props.monsterId)}`}></div>
    </div>
  </div>;
}
